import { render, staticRenderFns } from "./ResaleProfile.vue?vue&type=template&id=6ad70949&scoped=true"
import script from "./ResaleProfile.vue?vue&type=script&lang=js"
export * from "./ResaleProfile.vue?vue&type=script&lang=js"
import style0 from "./ResaleProfile.vue?vue&type=style&index=0&id=6ad70949&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad70949",
  null
  
)

export default component.exports